import { render, staticRenderFns } from "./AccountStatements.vue?vue&type=template&id=e2957430&scoped=true"
import script from "./AccountStatements.vue?vue&type=script&lang=js"
export * from "./AccountStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2957430",
  null
  
)

export default component.exports